export enum EmailSubmitFormVariant {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    outline = 'outline',
}
